import { firestoreAction } from 'vuexfire'
import _ from 'lodash'
import { storiesCollection } from '@/firebase/data'
import {currentUserId} from '@/firebase/firebase'
import { timestamp } from '@/firebase/firebaseHelpers'
import * as DateHelper from '@/helpers/date'

// import { midnight, areEqual, formatyyymmdd, dateIn, addDays } from '@/helpers/date'
// import Routine from '@/models/Routine'

// import state from './_state'
// import mutations from './_mutations'
// import actions from './_actions'
// import getters from './_getters'


// const todayTask = (task, getters) => task.deadline && areEqual(task.deadline.toDate(), getters.today)
// const overdueTask = (task, getters) => task.deadline && task.deadline.toDate() < getters.today
// const tomorrowTask = (task, getters) => task.deadline && areEqual(task.deadline.toDate(), getters.tomorrow)
// const dayAfterTomorrowTask = (task, getters) => task.deadline && areEqual(task.deadline.toDate(), addDays(getters.tomorrow, 1))
// const fromTodayTask = (task, getters, n) => task.deadline && areEqual(task.deadline.toDate(), addDays(getters.today, n))
// const deadlineAfterTomorrow = (task, getters) => task.deadline && task.deadline.toDate() > addDays(getters.tomorrow, 1)
// const getReviewFor = (task, getters) => !task.done || (task.doneOn && areEqual(task.doneOn.toDate(), getters.today))

const storyDefaults = {
  sentiment: 'neutral',
}

// const decorateReview = (review) => {
//   if (review) {
//     console.log('review.id', review.id)
//     return {...review, to: review.to.toDate(), from: review.from.toDate(), id: review.id  }
//   }
// }

export default {
  state: {
    stories: [],
    storiesDataLoaded: false
  },
  getters: {
    storiesDataLoaded: (state) => state.storiesDataLoaded,
    getStories: (state) => (date) => {
      return _.chain(state.stories)
        .filter((story) => story.deadline && DateHelper.areEqual(DateHelper.midnight(story.deadline.toDate()), DateHelper.midnight(date)))
        .sortBy('createdAt')
        .reverse()
        .value()
    },
    // getReview: (state) => (endDate, startDate, period) => {
    //   // return decorateReview(state.reviews[0])

    //   return decorateReview(_.chain(state.reviews)
    //     .filter((review) => review.period === period)
    //     .filter((review) => DateHelper.areEqual(DateHelper.midnight(review.to.toDate()), DateHelper.midnight(endDate)))
    //     .filter((review) => DateHelper.areEqual(DateHelper.midnight(review.from.toDate()), DateHelper.midnight(startDate)))
    //     .first()
    //     .value()) || reviewDefaults(endDate, startDate, period)
    // },
  },
  mutations: {
    setDataLoaded (state) {
      state.storiesDataLoaded = true
    }
  },
  actions: {
    bindStories: firestoreAction(context => {
      // context contains all original properties like commit, state, etc
      // and adds `bindFirestoreRef` and `unbindFirestoreRef`
      // we return the promise returned by `bindFirestoreRef` that will
      // resolve once data is ready
      return context.bindFirestoreRef(
        'stories',
        storiesCollection.where('uid', '==', currentUserId()),
        { wait: true }
      ).then(() => { context.commit('setDataLoaded') })
    }),
    ADD_STORY (_, { story }) {
      console.info('ADD_STORY', story)

      const newStory = Object.assign(storyDefaults, story, {
        uid: currentUserId(),
        createdAt: timestamp()
      })

      storiesCollection.add(newStory)
    },
    async DELETE_STORY (_, { story }) {
      console.info('DELETE_STORY', story)
      storiesCollection.doc(story.id).delete()
    },
    async UPDATE_STORY (_, { story, updateFields }) {
      console.info('UPDATE_STORY', story, updateFields)

      // if (updateFields.hasOwnProperty('deadline') || updateFields.hasOwnProperty('showList')) {
      //   console.log('removin list index')
      //   updateFields.listIndex = null
      // }

      storiesCollection.doc(story.id).update(updateFields)
    },
    // async DELETE_TASK ({ commit }, { task }) {
    //   const data = { task:
    //     { id: task.id,
    //       title: task.title,
    //       done: task.done,
    //       subtasks: task.subtasks,
    //       showList: task.showList,
    //       doneOn: task.doneOn,
    //       backgroundColor: task.backgroundColor,
    //       deadline: task.deadline,
    //     }
    //   }

    //   console.info('DELETE_TASK',
    //     task)
    //   tasksCollection.doc(task.id).delete()

    //   const reverse_detail = 'task deleted'

    //   const action = 'ADD_TASK'


    //   commit('SET_LAST_ACTION', { action, reverse_detail, data })
    // },
  }
}
